import React from 'react';
import { useTranslation } from 'react-i18next';

const SectionIoTService = () => {
  const { t } = useTranslation();
  return (
    <div className="section-iot-service">
      <div className="section-iot-service-item">
        <p className="label">{t('IoT Development Services')}</p>
        <p className="desc">
          {t(
            'Our IoT solutions connect devices, data, and processes to deliver seamless, real-time insights. We develop custom IoT applications and integrations for smart homes, industrial automation, healthcare, and beyond, ensuring scalability and security.'
          )}
        </p>
      </div>
      <div className="video">
        <div className="section-iot-service-item">
          <p className="label">{t('Whitelabel Solutions')}</p>
          <p className="desc">
            {t(
              'Launch your product faster with our fully customizable whitelabel software solutions. We provide ready-to-deploy platforms tailored to your brand, enabling you to focus on growth while we handle the technical foundation.'
            )}
          </p>
        </div>
        <video
          autoPlay
          loop
          muted
          playsInline
          src="/video/video-innovative-technology-solutions.mp4"
        ></video>
      </div>
    </div>
  );
};

export default React.memo(SectionIoTService);
